document.addEventListener('DOMContentLoaded', () => {
  const desktopLinks = document.querySelectorAll('.licenses-page__nav a[href^="#"]');
  const mobileLinks = document.querySelectorAll('.licenses-page__mobile-nav a[href^="#"]');
  const sectionLinks = [...desktopLinks, ...mobileLinks];
  const sections = document.querySelectorAll('.licenses-page__section');

  const mobileNav = document.querySelector('.licenses-page__mobile-nav');
  const mobileNavWrap = document.querySelector('.licenses-page__mobile-nav-wrap');
  const mobileNavTrigger = document.querySelector('.licenses-page__mobile-nav-trigger');
  const mobileNavSpacer = document.querySelector('.licenses-page__mobile-nav-spacer');

  const fab = document.getElementById('licensesFilterFab');
  const panel = document.getElementById('licensesFilterPanel');
  const panelLinks = document.querySelectorAll('.licenses-page__mobile-filter-link');

  if (!sectionLinks.length || !sections.length) return;

  let lastActiveId = null;
  let ticking = false;

  const getHeader = () => document.querySelector('.section-header, .shopify-section-group-header-group, .header-wrapper');

  const getHeaderHeight = () => {
    const header = getHeader();
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  };

  const getMobileNavHeight = () => {
    if (window.innerWidth > 749 || !mobileNavWrap) return 0;
    return Math.round(mobileNavWrap.getBoundingClientRect().height);
  };

  const getScrollOffset = (extraOffset = 12) => getHeaderHeight() + getMobileNavHeight() + extraOffset;

  const scrollToTarget = (target, extraOffset = 12) => {
    const heading = target.querySelector('h2') || target;
    const top = window.scrollY + heading.getBoundingClientRect().top - getScrollOffset(extraOffset);

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };

  const centerActiveLinkMobile = (activeLink, smooth = false) => {
    if (!mobileNav || !activeLink || window.innerWidth > 749) return;

    activeLink.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      inline: 'center',
      block: 'nearest'
    });
  };

  const setStickyMetrics = () => {
    document.documentElement.style.setProperty('--licenses-mobile-sticky-top', `${getHeaderHeight()}px`);
    document.documentElement.style.setProperty('--licenses-mobile-nav-height', `${getMobileNavHeight()}px`);
  };

  const updatePinnedState = () => {
    if (window.innerWidth > 749 || !mobileNavWrap || !mobileNavTrigger || !mobileNavSpacer) {
      mobileNavWrap?.classList.remove('is-pinned');
      mobileNavSpacer?.classList.remove('is-active');
      return;
    }

    const shouldPin = mobileNavTrigger.getBoundingClientRect().top <= getHeaderHeight();
    mobileNavWrap.classList.toggle('is-pinned', shouldPin);
    mobileNavSpacer.classList.toggle('is-active', shouldPin);
  };

  const setActiveLink = () => {
    const targetLine = getScrollOffset(24);
    let currentId = sections[0].id;
    let activeMobileLink = null;

    sections.forEach((section) => {
      const heading = section.querySelector('h2');
      if (!heading) return;

      if (heading.getBoundingClientRect().top <= targetLine) {
        currentId = section.id;
      }
    });

    sectionLinks.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${currentId}`;
      link.classList.toggle('is-active', isActive);

      if (isActive && link.closest('.licenses-page__mobile-nav')) {
        activeMobileLink = link;
      }
    });

    if (currentId !== lastActiveId) {
      centerActiveLinkMobile(activeMobileLink, false);
      lastActiveId = currentId;
    }
  };

  const updateAll = () => {
    setStickyMetrics();
    updatePinnedState();
    setActiveLink();
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;

    window.requestAnimationFrame(updateAll);
    ticking = true;
  };

  const closePanel = () => {
    if (!fab || !panel) return;
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
  };

  const openPanel = () => {
    if (!fab || !panel) return;
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
  };

  sectionLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      scrollToTarget(target, 12);

      if (link.closest('.licenses-page__mobile-nav')) {
        centerActiveLinkMobile(link, true);
      }
    });
  });

  if (fab && panel && panelLinks.length) {
    fab.addEventListener('click', () => {
      if (panel.hidden) openPanel();
      else closePanel();
    });

    panelLinks.forEach((link) => {
      link.addEventListener('click', () => {
        const target = document.querySelector(link.getAttribute('data-target'));
        if (!target) return;

        scrollToTarget(target, 20);
        closePanel();
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('#licensesFilterFabWrap')) {
        closePanel();
      }
    });
  }

  updateAll();

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', updateAll);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateAll);
  }
});
